module.exports = __webpack_public_path__ + "static/media/5-R-Smart Pro.1967d143.jpg";